export enum DateSelectDirection {
  PREVIOUS = 'previous',
  NEXT = 'next',
}

export enum DaySelectDirection {
  PREVIOUS = -1,
  NEXT = 1,
}

export enum WeekSelectDirection {
  PREVIOUS = -7,
  NEXT = 7,
}

export type DateDirection = DateSelectDirection | WeekSelectDirection

export enum DateSelectorMode {
  DAY = 'day',
  WEEK = 'week',
}

export type DateSelectorType = 'app' | 'insights' | 'meals' | 'allEvents' | 'plan'
